import { processApi } from '../../../utility/index';
import moment from "moment";
import { emailRule } from '@/utility/index.js';
import { setTimeout } from 'core-js';
export default {
    name: "CompanyManagement",
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            CompanyId: null,
            companyList: [],
            imageUrl: '',
            companyDetail: {},
            passType: '',
            outerVisible: false,
            innerVisible: false,
            resetPass: '',
            formLabelWidth: '140px',
            btnType: '',
            diaTitle: '',
            dialogFormVisible: false,
            rules: {
                jurisdictionName: [
                    { required: true, message: this.$t('JurisdictionalManagement.form.jurisdictionName'), trigger: 'blur' },
                ],
                jurisdictionNum: [
                    { required: true, message: this.$t('JurisdictionalManagement.form.jurisdictionNum'), trigger: 'blur' },
                ],
                loginName: [
                    { required: true, message: this.$t('JurisdictionalManagement.form.loginName'), trigger: 'blur' }
                ],
                userName: [
                    { required: true, message: this.$t('JurisdictionalManagement.form.userName'), trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: emailRule, trigger: 'blur' }
                ],
            },
            form: {
                jurisdictionName: '',
                loginName: '',
                jurisdictionNum: '',
                userName: '',
                logoPath: '',
                email: '',
                rolePower: ''
            },
            processImg: processApi,
            FileList: [],
            dialogRoleFormVisible: false,
            checkKeys: [],
            appCheckKeys: [],
            RoleForm: {
                menu: '',
                appMenu: ''
            },
            RoleRules: {},
            defaultProps: {
                children: 'children',
                label: 'zhName',
                disabled: "disabled"
            },
            data: [],
            appData: [],
            rolePowerName: '',
            appRolePowerName: '',
            rolePower: '',
            longitude: '',
            latitude: '',
            disabled: false,
            userId: '',
            roleList: []
        }
    },
    watch: {
        cen: {
            handler(oldValue, newValue) {
                console.log(oldValue, newValue)
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.getCompany();
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        
        getCompany() {
            this.$store.dispatch('JurisdictionalManagement/GET_GETJURISDICTION', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.companyList = []
                        res.data.data.map(item => {
                            this.companyList.push(item)
                        })
                        this.companyList.map((k, index) => {
                            if (index == 0) {
                                this.CompanyId = k.id
                                this.companyDetail = {
                                    jurisdictionName: k.jurisdictionName,
                                    loginName: k.loginName,
                                    email: k.email,
                                    createTime: moment(k.createTime).format('YYYY-MM-DD'),
                                    imgSrc: k.logoPath,
                                    jurisdictionNum: k.jurisdictionNum,
                                    userName: k.userName,
                                    lastUser: k.lastUser,
                                    updateTime: moment(k.updateTime).format('YYYY-MM-DD'),
                                    rolePower: k.rolePower,
                                    rolePowerName: k.rolePowerName
                                }
                                this.userId = k.userId
                                // this.rolePower = k.rolePower
                                // this.rolePowerName = k.menuNode
                                // this.appRolePowerName = k.appMenuNode
                            }
                        })
                    }
                }
            }).catch(err => { })
        },
        ChangCompany() {
            if (this.companyList) {
                this.companyList.map((item, index) => {
                    if (item.id == this.CompanyId) {
                        this.companyDetail = {
                            jurisdictionName: item.jurisdictionName,
                            loginName: item.loginName,
                            email: item.email,
                            createTime: moment(item.createTime).format('YYYY-MM-DD'),
                            imgSrc: item.logoPath,
                            jurisdictionNum: item.jurisdictionNum,
                            userName: item.userName,
                            lastUser: item.lastUser,
                            updateTime: moment(item.updateTime).format('YYYY-MM-DD'),
                            rolePower: item.rolePower,
                            rolePowerName: item.rolePowerName
                        }
                        this.userId = item.userId
                        // this.rolePower = item.rolePower
                        // this.rolePowerName = item.menuNode
                        // this.appRolePowerName = item.appMenuNode
                    }
                })
            }
        },
        changePass() {
            this.outerVisible = true
        },
        resetSubmit() {
            this.innerVisible = true
            let param = {
                id: this.userId
            }
            this.$store.dispatch('userManagement/GET_RESETPASSWORD', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.resetPass = res.data.data
                        this.outerVisible = false
                        this.$message.success(this.$t('JurisdictionalManagement.resetPassSuccess'))
                    } else {
                        this.innerVisible = true
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(err => {
                this.innerVisible = true
            })
        },
        addCompany() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('JurisdictionalManagement.add')
            this.disabled = false
            this.btnType = 'add'
            this.getRole()
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                this.FileList = []
                this.form.jurisdictionName = ''
                this.form.logoPath = ''
                this.imageUrl = ''
            })
        },
        editCompany() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('JurisdictionalManagement.edit')
            this.disabled = true
            this.btnType = 'edit'
            this.getRole()
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.jurisdictionName = this.companyDetail.jurisdictionName
                this.form.loginName = this.companyDetail.loginName
                this.form.jurisdictionNum = this.companyDetail.jurisdictionNum
                this.form.userName = this.companyDetail.userName
                this.form.logoPath = this.companyDetail.imgSrc
                this.imageUrl = this.companyDetail.imgSrc
                this.form.email = this.companyDetail.email
                this.form.rolePower = this.companyDetail.rolePower
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        jurisdictionName: this.form.jurisdictionName,
                        loginName: this.form.loginName,
                        jurisdictionNum: this.form.jurisdictionNum,
                        userName: this.form.userName,
                        logoPath: this.form.logoPath,
                        email: this.form.email,
                        rolePower: this.form.rolePower
                    }
                    console.log(param)
                    if (this.btnType == 'add') {
                        this.$store.dispatch('JurisdictionalManagement/GET_INSERTJURISDICTION', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getCompany();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        this.$store.dispatch('JurisdictionalManagement/GET_UPDATEJURISDICTION', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getCompany();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }

                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                jurisdictionName: '',
                loginName: '',
                jurisdictionNum: '',
                userName: '',
                logoPath: '',
                email: '',
                rolePower: ''
            }
        },
        closeDia() {
            this.form = {
                jurisdictionName: '',
                loginName: '',
                jurisdictionNum: '',
                userName: '',
                logoPath: '',
                email: '',
                rolePower: ''
            }
            this.dialogFormVisible = false;
        },

        getRole() {
            this.$store
              .dispatch('roleManagement/GET_SELECTTEMPLATEROLE', {})
              .then((res) => {
                if (res) {
                  if (res.data.code == 200) {
                    this.roleList = res.data.data
                  }
                }
              })
              .catch((err) => { })
          },
        handleAvatarSuccess(res, file) {
            console.log(res, file)
            const arr = []
            this.FileList.push({
                url: res,
            })
            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.imageUrl = URL.createObjectURL(file.raw);
            this.form.logoPath = arr.join('')
            console.log(this.form.logoPath)
        },
        handleRemove(file, fileList) { },
        deleteCompany() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { jurisdictionNum : this.companyDetail.jurisdictionNum  }
                    this.$store.dispatch('JurisdictionalManagement/GET_DELETEJURISDICTION', param).then(response => {
                        if (response.data.code == 200) {
                            this.getCompany()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        // getMenu() {
        //     this.$store.dispatch('tree/GET_GETMENUNODE', {}).then(res => {
        //         if (res) {
        //             if (res.data.code == 200) {
        //                 this.data = res.data.data
        //             }
        //         }
        //     })
        // },
        // getAppMenu() {
        //     this.$store.dispatch('tree/GET_GETAPPMENUNODE', {}).then(res => {
        //         if (res) {
        //             if (res.data.code == 200) {
        //                 this.appData = res.data.data
        //             }
        //         }
        //     })
        // },
        // changeRole() {
        //     this.dialogRoleFormVisible = true;
        //     this.$nextTick(() => {
        //         this.getMenu()
        //         this.getAppMenu()
        //         this.$refs.RoleForm.clearValidate()
        //         this.RoleForm.menu = this.rolePowerName
        //         this.RoleForm.appMenu = this.appRolePowerName
        //         this.checkKeys = []
        //         this.appCheckKeys = []
        //         if (this.RoleForm.menu) {
        //             var txt = this.rolePowerName.split(',')
        //             txt.map((item, index) => {
        //                 this.checkKeys.push(item)
        //             })
        //             this.$refs.tree.setCheckedKeys(this.checkKeys)
        //         }
        //         if (this.RoleForm.appMenu) {
        //             var txts = this.appRolePowerName.split(',')
        //             txts.map((items, k) => {
        //                 this.appCheckKeys.push(items)
        //             })
        //             this.$refs.appTree.setCheckedKeys(this.appCheckKeys)
        //         }
        //     })


        // },
        // closeRoleDia() {
        //     this.dialogRoleFormVisible = false
        // },
        // submitRoleForm(RoleFormName) {
        //     this.$refs[RoleFormName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 id: this.rolePower,
        //                 menu: this.$refs.tree.getCheckedKeys().join(','),
        //                 appMenu: this.$refs.appTree.getCheckedKeys().join(',')
        //             }
        //             console.log(param.appMenu)
        //             this.$store.dispatch('roleManagement/GET_UPDATEROLE', param).then(res => {
        //                 if (res.data.code == 200) {
        //                     this.$message.success(this.$t('common.btn.editSuccess'))
        //                     this.dialogRoleFormVisible = false;
        //                     this.getCompany();
        //                     this.closeRoleDia();
        //                 } else {
        //                     this.$message.error(res.data.msg)
        //                 }

        //             }).catch(err => { })

        //         } else {
        //             return false;
        //         }
        //     });
        // },
        // cancleRoleForm() {
        //     this.dialogRoleFormVisible = false
        // },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}